import getImageUrl from './get-image-url'
import Breadcrumb from './Breadcrumb.jsx'
import PageHeader from './PageHeader.jsx'
import { useMediaQuery } from 'react-responsive'

const Exterior = () => {
  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  return (
    <>
      <div>
        <PageHeader
          title={'外構・造成工事について'}
          image={getImageUrl('EXTERIOR.png')}
        />
        <div className="content-area">
          <Breadcrumb
            current={'外構・造成工事について'}
            site_url={import.meta.env.VITE_SITE_URL}
            items={[]}
          />
        </div>
        <div className="pt-[calc(88vw/7.5)] pb-[calc(206vw/7.5)] lg:pt-[114px] lg:pb-[230px]">
          <div className="content-area">
            <h2>外構工事</h2>
            <h3 className="mt-[min(calc(100vw/7.5),50px)] md:mt-[70px]">外構エクステリア工事</h3>
            <p className="mt-[22px]">
              横浜総合建設では解体工事だけでなく、外構エクステリア工事も行えます。
            </p>
            <img
              src={getImageUrl('exterior-image-1.png')}
              alt=""
              className="mt-[60px]"
            />
            <h4 className="mt-[50px]">駐車場</h4>
            <div className="grid lg:grid-cols-2 gap-[40px] mt-[40px]">
              <img
                src={getImageUrl('exterior-image-2.png')}
                alt=""
              />
              <img
                src={getImageUrl('exterior-image-3.png')}
                alt=""
              />
            </div>
            <h4 className="mt-[50px]">テラス＆アプローチ</h4>
            <div className="grid lg:grid-cols-2 gap-[40px] mt-[40px]">
              <img
                src={getImageUrl('exterior-image-4.png')}
                alt=""
              />
              <img
                src={getImageUrl('exterior-image-5.png')}
                alt=""
              />
            </div>
          </div>
        </div>
        <div className="bg-[#F4FBFF] pt-[calc(88vw/7.5)] pb-[calc(206vw/7.5)] lg:pt-[206px] lg:pb-[152px]">
          <div className="content-area">
            <h3 className="mt-[70px]">造成工事</h3>
            <p className="mt-[22px]">
              横浜総合建設では地下車庫工事・ブロック塀・RC擁壁工事・土間・アスファルト工事などの造成工事も行なっております。
            </p>
            <h4 className="mt-[50px]">造成工事</h4>
            <div
              className={
                isPC ? 'flex gap-[40px] mt-[40px]' : 'grid gap-[calc(48vw/7.5)] mt-[calc(90vw/7.5)]'
              }
            >
              <img
                src={getImageUrl('exterior-image-6.png')}
                alt=""
              />
              <div>
                <p>
                  道路より低い（3ｍ程度）土地を道路と同じ高さにすることで駐車場が出来、階段を使わず玄関へ出入り可能に。土地の価値も上がります。
                </p>
              </div>
            </div>
            <h4 className="mt-[50px]">擁壁工事</h4>
            <div
              className={
                isPC ? 'flex gap-[40px] mt-[40px]' : 'grid gap-[calc(48vw/7.5)] mt-[calc(90vw/7.5)]'
              }
            >
              <img
                src={getImageUrl('exterior-image-7.png')}
                alt=""
              />
              <div>
                <p>
                  各種申請・設計・構造計算・工事の全てをお任せください。その他、ライフライン（上下水道・ガス）にも対応しています。是非ご相談を。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        h2 {
          text-align: center;
          font: normal normal bold calc(50vw / 7.5) Noto Sans JP;
          color: #2964b6;
        }
        h3 {
          text-align: left;
          font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
          color: #f9d022;
          background: #2964b6 0% 0% no-repeat padding-box;
          padding: calc(9vw / 7.5) calc(28vw / 7.5);
        }
        h4 {
          font: normal normal bold calc(40vw / 7.5) Noto Sans JP;
          color: #2964b6;
          border-bottom: 2px solid #2964b6;
        }
        p {
          font: normal normal normal calc(33vw / 7.5) Noto Sans JP;
          text-align: center;
        }
        @media screen and (min-width: 1024px) {
          h2 {
            text-align: center;
            font: normal normal bold 80px/80px Noto Sans JP;
            color: #2964b6;
          }
          h3 {
            text-align: left;
            font: normal normal bold 30px/58px Noto Sans JP;
            color: #f9d022;
            background: #2964b6 0% 0% no-repeat padding-box;
            padding: 0 14px;
          }
          h4 {
            font: normal normal bold 30px/58px Noto Sans JP;
            color: #2964b6;
            border-bottom: 2px solid #2964b6;
          }
          p {
            font: normal normal normal 24px/40px Noto Sans JP;
            text-align: left;
          }
        }
      `}</style>
    </>
  )
}

export default Exterior
